import { onMounted, onUnmounted, ref } from 'vue';
import { addNABackToWebviewEvent } from '@q-front-npm/jsbridge';
export const usePageShowHide = ({ onPageShow, onPageHide, }: { onPageShow?: () => void; onPageHide?: () => void }) => {
    const isPageVisible = ref(true);
    addNABackToWebviewEvent((type: string) => {
        if (type === 'resume') {
            isPageVisible.value = true;
            onPageShow?.();
        } else {
            isPageVisible.value = false;
            onPageHide?.();
        }
    });

    return {
        isPageVisible,
    };
};
